import React from "react";
import  { useState, useEffect } from 'react';
import './classes/ScoutBio.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";


const ScoutBio = () =>{
     const [isLoading, setIsLoading] = useState(true);
      const [bioDetails, setBioDetails] = useState({});
      const [scoutReport, setScoutReport] = useState({});
      const messages = [
  {
    text: "Just give him a try and you will love his playing role?",
    category: "soccer",
    link: ""
  },
  {
    text: "Who is ready for the brilliant goalkeeper if you need his videos kindly reach me for more details?",
    category: "soccer",
    link: ""
  },
   {
    text: "Just give him a try and you will love his playing role?",
    category: "soccer",
    link: ""
  },
  {
    text: "Who is ready for the brilliant goalkeeper if you need his videos kindly reach me for more details?",
    category: "soccer",
    link: ""
  },
   {
    text: "Just give him a try and you will love his playing role?",
    category: "soccer",
    link: ""
  },
  {
    text: "Who is ready for the brilliant goalkeeper if you need his videos kindly reach me for more details?",
    category: "soccer",
    link: ""
  },
   {
    text: "Just give him a try and you will love his playing role?",
    category: "soccer",
    link: ""
  },
  {
    text: "Who is ready for the brilliant goalkeeper if you need his videos kindly reach me for more details?",
    category: "soccer",
    link: ""
  },

];
  const profile = {
    id: "582272",
    name: "Justin Akiva",
    image: "/images/Adam.png",
    location: "Tenafly, New Jersey, United States",
    email: "jakiva@SMWW.com",
    bio: `
      Justin Akiva currently resides in Cresskill, NJ with his family. 
      He graduated from Boston University in 2016 with his Bachelor of Science in Film & Television. 
      After his time at Boston University, he became part of the National Basketball Association. 
      Justin entered the league as an intern with the live production department and is now currently working 
      in the media operations & technology department. During his time at the NBA, Justin took his first course 
      with Sports Management Worldwide, Digital Video Editing with Synergy. He took the course in order to obtain 
      the initial skills to enter a collegiate or professional level video room.
      
      When Justin is out of the office he is either watching, playing, or teaching basketball. 
      He has a true passion for the game and wants to be around the game of basketball for the rest of his life. 
      Justin is excited to be a part of the Net Scouts program and is looking forward to taking another step 
      in order to achieve his dream of being part of an NBA team.
    `,
  };
      const navigate = useNavigate();
      const app_url = configData.APP_URL;
      const {slug} = useParams();
       useEffect(() => {
              Promise.all([
                  retrieveScoutBioDetails(),
                  retrieveScoutReport()
              ])
              .then(() => {
           
              setIsLoading(false);
              })
           
          },[]);
          
       async function retrieveScoutBioDetails() {
          if(slug) {
             try {
              
          const response = await fetch(
            app_url+'smwwscout/getscoutbiodetails?slug='+slug,
            {
              method: "GET",
        
              headers: {
                'Content-Type': 'application/json',
              },
            }
          )
          const responsedata = await response.json();
          if(responsedata.data.msg === "Success") {
            setBioDetails(responsedata.data.result);
          }
          } catch (error) {
              console.error(error);
            }finally {
                   // Set loading to false after fetch completes (success or error)
                }
        }
        }
        async function retrieveScoutReport() {
          if(slug) {
             try {
              
          const response = await fetch(
            app_url+'smwwscout/getscoutreport?slug='+slug,
            {
              method: "GET",
        
              headers: {
                'Content-Type': 'application/json',
              },
            }
          )
          const responsedata = await response.json();
          if(responsedata.data.msg === "Success") {
            setScoutReport(responsedata.data.result);
          }
          } catch (error) {
              console.error(error);
            }finally {
                   // Set loading to false after fetch completes (success or error)
                }
        }
        }
    return(
        <>
                {isLoading ? (
                    <Loading />
                ) : (
                    <div id="main" class="three-column-layout scout-bio">
                        <Helmet><title>{bioDetails.meta_title}</title></Helmet>
                        <div className="left">
                           <h2>Scouting Reports</h2>
                              {scoutReport.length > 0 && (
                            <div class="successboxx">
                                    <ul>                                      
                                    {scoutReport.map((item, index) => (
                                        <li key={index}>
                                        <a href={item.link} target="_blank" rel="noopener noreferrer">
                                            {item.title}
                                        </a>{" "}
                                        {item.sports && (
                                          <>
                                        ({item.sports})</>
                                        )}
                                        </li>
                                    ))}
                                    </ul>
                            </div>
                              )}
                        </div>
                        <div className="center">
                         {bioDetails.message  ? (
                          <>{bioDetails.message}</> 

                         ) : ( 
                          <>
                     <table border="0"id={`scout-bid-${profile.id}`}>
                    <tbody>
                        <tr valign="top">
                        <td width="110" valign="top">
                            <img src={bioDetails.picture}  />
                        </td>
                        <td className="bio-td">
                            <h1>{bioDetails.name}</h1>
                            <div className="agent-email">
                            <div className="address">{bioDetails.location}</div>
                            <a href={`mailto:${bioDetails.email}`}>{bioDetails.email}</a>
                            </div>
                        </td>
                        </tr>
                        </tbody>
                    </table>
                         <div>
                        <div className="bio">
                          <div style={{marginTop: "25px"}}>
                             <div className="bio-content" dangerouslySetInnerHTML={{ __html: bioDetails.field_scout_biography }}></div>
                            </div>
                        </div>
                        </div> 
                    </>  
                    )}
                        </div>
                        <div className="right">
                             {/* {
                              (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
                              userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
                              userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))
                                  &&  */}
                                  <SalespersonSidebar /> 
                              {/* }  */}
                        </div>
                    </div>
                )}
                </>

    );
};
export default ScoutBio;